import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { SITE, CITIES, IMAGES, cityPath } from '../data/site';

const serviceLinks = [
  { label: 'Heating & Air Conditioning', path: '/heating-air-conditioning' },
  { label: 'AC Repair', path: '/air-conditioning-repair-stanfield-nc' },
  { label: 'AC Installation & Replacement', path: '/air-conditioning-installation-stanfield-nc' },
  { label: 'Heating Repair & Installation', path: '/heating-repair-installation-stanfield-nc' },
  { label: 'Plumbing Services', path: '/plumbing' },
  { label: 'Excavation & Trenching', path: '/excavation-trenching' },
  { label: 'Indoor Air Quality', path: '/indoor-air-quality' },
  { label: 'American Standard Products', path: '/products' },
  { label: 'Financing', path: '/financing' },
  { label: 'Promotions', path: '/promotions' },
  { label: 'Project Gallery', path: '/gallery' },
];

export default function Footer() {
  return (
    <footer className="relative bg-navy-dark text-slate-300 grain" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img
              src={IMAGES.logoTransparent}
              alt="B.E. Holbrooks Co. - over 60 years of HVAC and plumbing service in Stanfield, NC"
              className="mb-5 h-14 w-auto"
            />
            <p className="text-sm leading-relaxed text-slate-400">
              Family-owned heating, air conditioning, plumbing, and excavation company serving Stanfield and the
              greater Charlotte area for over 60 years.
            </p>
            <img
              src={IMAGES.americanStandard}
              alt="American Standard Customer Care Dealer - B.E. Holbrooks Co."
              className="mt-5 h-14 w-auto rounded-md bg-white p-1"
            />
          </div>

          <nav aria-label="Footer services">
            <h3 className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-sky-400">Services</h3>
            <ul className="space-y-2 text-sm">
              {serviceLinks.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="transition-colors hover:text-white" data-testid={`footer-service-${l.path.replace(/\//g, '')}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Footer service areas">
            <h3 className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-sky-400">Service Areas</h3>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
              {CITIES.map((c) => (
                <li key={c.slug}>
                  <Link to={cityPath(c.slug)} className="transition-colors hover:text-white" data-testid={`footer-city-${c.slug}`}>
                    {c.name}, NC
                  </Link>
                </li>
              ))}
            </ul>
            <Link to="/service-areas" className="mt-3 inline-block text-sm font-semibold text-sky-400 hover:text-sky-300" data-testid="footer-all-areas">
              View all service areas
            </Link>
          </nav>

          <div>
            <h3 className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-sky-400">Contact</h3>
            <address className="space-y-3 text-sm not-italic" data-testid="footer-nap">
              <p className="font-display text-base font-bold text-white">{SITE.name}</p>
              <p className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-sky-400" />
                {SITE.address}<br />{SITE.cityStateZip}
              </p>
              <p>
                <a href={SITE.phoneHref} className="flex items-center gap-2 font-semibold text-white hover:text-sky-300" data-testid="footer-phone">
                  <Phone className="h-4 w-4 text-sky-400" /> {SITE.phone}
                </a>
              </p>
              <p>
                <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-white" data-testid="footer-email">
                  <Mail className="h-4 w-4 text-sky-400" /> {SITE.email}
                </a>
              </p>
            </address>
            <p className="mt-4 text-xs leading-relaxed text-slate-500">
              Heating, Air Conditioning, Plumbing, Excavation, Trenching & Indoor Air Quality. Visit our hardware and
              garden store at 204 West Stanly Street.
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-slate-500 sm:flex-row sm:px-6 lg:px-12">
          <p>© {new Date().getFullYear()} {SITE.name} All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-white">About</Link>
            <Link to="/contact" className="hover:text-white">Contact</Link>
            <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
